import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PrimaryModalComponent} from './primary-modal/primary-modal.component';

@NgModule({
  imports: [CommonModule],
  exports: [PrimaryModalComponent],
  declarations: [
    PrimaryModalComponent,
  ],
  providers: [],
})
export class ModalModule {
}
